var React = require('react');

function DotCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm124.45 372.45A176 176 0 1 1 432 256a174.85 174.85 0 0 1-51.55 124.45z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 336a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80z","className":"fa-primary","key":2})]);
}

DotCircle.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = DotCircle;

DotCircle.default = DotCircle;
